import React from "react";
const PaymentDetailsTable = ({
  lo_recordForPrint = {},
}) => {
  return (
   <>
   <table className="calculate-sec" style={{ height: "180px" }}>
          <tbody>
           <tr>
              <td className="first">Business Name :</td>
              <td className="first"><b>{lo_recordForPrint.store_details?.store_name}</b></td>
            </tr>
            <tr>
              <td className="first">Customer Name :</td>
              <td className="first"><b>{lo_recordForPrint.customer?.cust_first_name + " " + lo_recordForPrint.customer?.cust_last_name}</b></td>
            </tr>
            <tr>
              <td className="first">Invoice Number :</td>
              <td className="first"><b>{lo_recordForPrint.order_no}</b></td>
            </tr>
            <tr>
              <td>Amount Due :</td>
              <td><b>KSH {lo_recordForPrint.total_amount}</b></td>
            </tr>
            <tr>
              <td>Due Date :</td>
              <td><b>{new Date(lo_recordForPrint.created_date).toLocaleDateString()}</b></td>
            </tr>
            <tr>
              <td className="first">Status :</td>
              <td className="first"><b style={{color: (lo_recordForPrint.payment_status == "Due") ? "red" : "#1f9d3fbf"}}>{lo_recordForPrint.payment_status}</b></td>
            </tr>
          </tbody>
        </table>
   </>
  );
};

export default PaymentDetailsTable;
